<template>
  <el-container>

    <el-row :gutter="10">
      <el-col :span="24">
          <el-row :gutter="10">
            <el-col :span="12">
              <el-form :inline="true" size="mini">
                <el-form-item>
                  <el-button type="primary" icon="el-icon-edit" @click="apiUserForm(0)">新增</el-button>
                </el-form-item>
                <el-form-item>
                  <el-button type="default" icon="el-icon-delete" @click="removeApiUser(0)">删除</el-button>
                </el-form-item>
              </el-form>
            </el-col>
            <el-col :span="12">
              <el-form :inline="true" :model="formInline" size="mini" class="smui-form-right">
                <el-form-item label="用户">
                  <el-input v-model="formInline.hold_name" placeholder="用户名称检索" clearable></el-input>
                </el-form-item>
                <el-form-item label="Api Key">
                  <el-input v-model="formInline.api_key" placeholder="Api Key检索" clearable></el-input>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" icon="el-icon-search" @click="queryApiUserList()">查询</el-button>
                </el-form-item>
              </el-form>
            </el-col>
          </el-row>
          
          <div class="sanmuui-body-container">
              <el-table
                id="tbGridView"
                ref="getTableInstance"
                :data="tableData"
                :height="tableViewHeight"
                v-loading="loadingTableData"
                @selection-change="handleSelectionChange"
                size="small"
                border
                style="width: 100%">
                <el-table-column
                  type="selection"
                  width="55">
                </el-table-column>
                <el-table-column
                  prop="hold_name"
                  label="用户名"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="api_key"
                  label="API Key"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="api_secret"
                  label="API Secret"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="status"
                  label="状态"
                  width="80">
                </el-table-column>
                <el-table-column
                  prop="rate_limit"
                  label="限制"
                  width="100">
                </el-table-column>
                <el-table-column
                  prop="expiry_date"
                  label="到期"
                  :formatter="formatExpiredTime"
                  width="150">
                </el-table-column>
                <el-table-column
                  prop="created_time"
                  label="创建"
                  :formatter="formatCreatedTime"
                  width="200">
                </el-table-column>
                <el-table-column
                  prop="operator"
                  label="操作"
                  width="300">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="apiUserForm(scope.row.api_id)">编辑</el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      @click="removeApiUser(scope.row.api_id)"
                      v-if="scope.row.hold_id!=1">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
          </div>

          <div class="dv-pagging-container">
            <el-pagination
              background
              layout="prev, pager, next"
              @current-change="handleCurrentChange"
              :page-size="pagging.pager_size"
              :pager-count="pagging.pager_count"
              :total="pagging.records_total"
              :current-page="pagging.current_page">
            </el-pagination>
          </div>
      </el-col>
    </el-row>

    <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" width="800px">
      <el-row>
        <el-col :span="10">
          <div class="tree-divBox">
              <el-tree 
                  :data="holdTreeData" 
                  :props="defaultProps" 
                  default-expand-all 
                  ref="getTreeInstance" 
              @node-click="handleAllocateNodeClick"></el-tree>
          </div>
        </el-col>
        <el-col :span="14">
          <el-form :model="formNew" :rules="rules" ref="formNew" size="medium">
            <el-form-item label="选择用户" :label-width="formLabelWidth" prop="hold_name">
              <el-input v-model="formNew.hold_name" autocomplete="off" class="-form2-input-text"></el-input>
            </el-form-item>
            <el-form-item label="API Key" :label-width="formLabelWidth" prop="api_key">
              <el-button @click="activeGenerate" size="mini">动态生成</el-button>
              <el-input v-model="formNew.api_key" autocomplete="off" class="-form2-input-text"></el-input>
            </el-form-item>
            <el-form-item label="API Secret" :label-width="formLabelWidth" prop="api_secret">
              <el-input type="textarea" v-model="formNew.api_secret"></el-input>
            </el-form-item>
            <el-form-item label="调用限制/每天" :label-width="formLabelWidth" prop="rate_limit">
              <el-input v-model="formNew.rate_limit" autocomplete="off" class="-form2-input-text"></el-input>
            </el-form-item>
            <el-form-item label="有效期" :label-width="formLabelWidth" prop="expiry_date">
              <el-date-picker
                v-model="formNew.expiry_date"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="状态" :label-width="formLabelWidth" prop="status">
              <el-radio-group v-model="formNew.status">
                <el-radio :label="1">开启</el-radio>
                <el-radio :label="0">关闭</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="addApiUser('formNew')" size="small">确 定</el-button>
        </div>
    </el-dialog>

  </el-container>
</template>

<script>
import Api from '../../api/index'

export default {
  name: 'holdapi_manage',
  data() {
    return {
      isVisible: false, // 控制浮动层是否显示
      dialogFormVisible: false,
      dailRepwdVisible: false,
      dialogTitle: "新增用户",
      formInline: {
        hold_name: '',
        api_key: '',
        page_index: 1,
        page_size: 20,
        sort_field: '',
        sort_type: ''
      },
      card_type_options: [
        { value: '1', label: '移动卡' },
        { value: '2', label: '联通卡' },
        { value: '3', label: '海外卡' }
      ],
      displayPassword: false,
      formLabelWidth: "110px",
      formNew: {
        api_id: 0,
        hold_id: 0,
        hold_name: "",
        api_key: "",
        api_secret: "",
        rate_limit: "",
        expiry_date: "",
        status: "1",
      },
      rules: {
        hold_name: [
          { required: true, message: '请选择用户', trigger: 'blur' }
        ]
      },
      tableViewHeight: 600,
      multipleSelection: [],
      loadingTableData: false,
      selectHoldId: 0,
      selectedHoldName: "",
      holdTreeData: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      tableData: [],
      pagging: {
        records_total: 0,
        pager_count: 5,
        pager_size: 20,
        current_page: 1
      },
      selectUserId: 0,
      selectUserName: '',
    }
  },
  methods: {
    openLayer() {
      this.isVisible = true;
    },
    closeLayer() {
      this.isVisible = false;
    },
    handleCurrentChange(val) {
      this.pagging.current_page = val;
      this.queryApiUserList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    refreshPageList: function() {
      this.queryApiUserList();
    },
    handleAllocateNodeClick: function(data) {
      this.formNew.hold_id = data.id;
      this.formNew.hold_name = data.label;
    },
    formatExpiredTime(row, column) {
      return row.expiry_date ? row.expiry_date.replace('T', ' ').substring(0, 10) : "";
    },
    formatCreatedTime(row, column) {
      return row.created_time ? row.created_time.replace('T', ' ').substring(0, 19) : "";
    },
    loadHoldTree: function(){
      Api.GetHoldTree({}).then(res => {
        if(!res)
          return;

        if(res.code !== 200)
          return;

        this.holdTreeData = res.data;

        // 初始化选中的用户id
        this.selectHoldId = this.holdTreeData[0].id;
        this.selectedHoldName = this.holdTreeData[0].label;
      });
    },
    queryApiUserList: function() {
      this.loadingTableData = true;
      this.tableData = [];
      Api.ApiUserList(this.formInline).then(res => {
        this.loadingTableData = false;
        if(res && res.code === 200 && res.data) {
          this.pagging.records_total = res.total;
          // let startNum = (this.pagging.current_page - 1) * this.pagging.pager_size;
          this.tableData = res.data;
        } else {
          // this.$message.error(err);
        }
      }).catch(err => {
        this.$message.error('错了哦，接口出错！' + err);
        this.loadingTableData = false;
      });
    },
    handleSelectCardType: function(cmd) {
      this.formNew.card_type_text = cmd.label;
      this.formNew.card_type = parseInt(cmd.value);
    },
    resetForm: function() {
      this.formNew = {
        api_id: 0,
        hold_name: "",
        api_key: "",
        api_secret: "",
        rate_limit: "",
        expiry_date: "",
        status: "1",
      };
    },
    apiUserForm: function(id) {
      this.resetForm();
      this.formNew.api_id = id;
      this.dialogFormVisible = true;
      if(id > 0) {
        this.displayPassword = false;
        this.dialogTitle = "修改API User";
        Api.ApiUserDetail({ api_id: id }).then(res => {
          if(res && res.code === 200 && res.data) {
            this.formNew.hold_id = res.data.hold_id;
            this.formNew.hold_name = res.data.hold_name;
            this.formNew.api_key = res.data.api_key;
            this.formNew.api_secret = res.data.api_secret;
            this.formNew.rate_limit = res.data.rate_limit;
            this.formNew.status = res.data.status;
            this.formNew.expiry_date = res.data.expiry_date;
          } else {
            this.$message.error(`出错了！${res ? res.msg : ''}`);
          }
        });
      } else {
        this.displayPassword = true;
        this.dialogTitle = "新增API User";
      }
    },
    addApiUser: function(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          Api.AddApiUser(this.formNew).then(res => {
            if(res && res.code === 200) {
              this.$message({
                message: '提交成功！',
                type: 'success'
              });
              this.resetForm();
              this.dialogFormVisible = false;
              this.queryApiUserList();
            } else {
              this.$message.error(`提交失败！${res ? res.msg : ''}`);
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    activeGenerate: function() {
      // 动态生成KEY并填充文本框
      Api.GenerateKeySecret().then(res => {
        if(res && res.code === 200) {
          this.formNew.api_key = res.data.key;
          this.formNew.api_secret = res.data.secret;
        }
      });
    },
    removeApiUser: function(id) {
      this.$confirm('此操作将删除该卡源, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      }).then(() => {
        var masters = [];
        if(id == 0) {
          if(this.multipleSelection.length > 0) {
            this.multipleSelection.forEach(s => {
              masters.push(s.hold_id);
            });
          } else {
            this.$message({
                message: '请选择卡源',
                type: 'warning'
            });
            return;
          }
        } else {
          masters.push(id);
        }
         var argdata = {
            source_ids: masters
          };
          Api.removeApiUser(argdata).then(res => {
            if(!res)
              return;

            if(res.code === 200) {
                this.$message({
                    message: '已删除！',
                    type: 'success'
                });
                this.queryApiUserList();
            } else {
                this.$message({
                    message: '删除失败！' + res.msg,
                    type: 'warning'
                });
            }
          });
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // });
      });
    }
  },
  mounted() {
    var h = document.body.clientHeight - 60 - 130;
    var h2 = document.body.clientHeight - 115;
    this.$nextTick(() => {
      const table = this.$refs.getTableInstance;
      if (table) {
        // 使用原生JavaScript设置高度
        table.$el.style.height = h + 'px';
        // 或者使用Vue.set来响应式地更新样式
        // this.$set(table.$el.style, 'height', '300px');
      }
      const tree = this.$refs.getTreeInstance;
      if(tree) {
        tree.$el.style.height = h2 + 'px';
      }
    });

    this.loadHoldTree();
    this.queryApiUserList();
  }
}
</script>
<style>
.tree-divBox {
  padding-top: 10px;
  padding-left: 10px;
  width: 95%;
  min-height: 500px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
}
.smui-form-right {
  float: right;
}

</style>